import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { getRedirectUrl, authzAppCode, listHotels } from "../service/cas";
import { authAppWidthOAuth2 } from "../service/oauth";
import { assertionSMAL2 } from "@/service/appList.js";
import { Message } from "view-design";
import store from "store2";
import { getBrowerLang } from "../utils/util";
// import { device } from "device.js";
function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}
export const open = (url, open) => {
  try {
    if (open) {
      if (isIOS()) {
        //ios模式下
        window.location.href = url;
      } else {
        window.open(url);
      }
    } else {
      location.href = url;
    }
  } catch (error) {
    console.log(error);
  }
};
const language = store.get("language") || getBrowerLang() || "zh-CN";
let languageCode = ["OIG", "DEV_CENTER", "ISV_MANAGE", "EXPENSE_CENTER"];
export const openApp = async (_this, item) => {
  if (item.protocol === "SAML2.0") {
    SAML2ApiValid(item);
  } else if (item.protocol === "EXTENDAPI") {
    // 腾讯邮箱
    let res = await authzAppCode(item.code);
    if (res.data && res.data.result == 0) {
      open(res.data.retVal, true);
    }
  } else if (item.protocol === "LC_USE") {
    //本地配置使用
    _this.$router.push({
      path: "/MGT/AppUse",
      query: {
        code: item.code,
        id: item.id
      }
    });
  } else if (item.protocol === "OAUTH2") {
    const res = await authAppWidthOAuth2(item.code);
    if (res.data && res.data.result == 0) {
      open(res.data.retVal, true);
    }
  } else {
    const res = await getRedirectUrl(item.code);
    if (res.data && res.data.result == 0) {
      const {
        appUrl,
        jwtToken,
        downLoadUrl
      } = res.data.retVal;
      if (item.protocol == "JWT") {
        if (jwtToken !== "HOTEL") {
          if (downLoadUrl) {
            _this.$refs.OpenAppModal.show(item.code);
            // _this.$refs.openApp.show();
            // let routeUrl = _this.$router.resolve({
            //   path: "/openApp",
            //   query: { appId: item.code },
            // });
            // window.open(routeUrl.href, "_blank");
          } else if (appUrl) {
            open(`${appUrl}?token=${jwtToken}`, true);
          } else {
            open(`${item.code}://?token=${jwtToken}`);
          }
        } else {
          const res2 = await listHotels();
          if (res2.data && res2.data.result === 0) {
            var _res2$data;
            _this.$refs.UnitSelect.show((_res2$data = res2.data) === null || _res2$data === void 0 || (_res2$data = _res2$data.retVal) === null || _res2$data === void 0 ? void 0 : _res2$data.datas, item.code, downLoadUrl);
          }
        }
      } else if (languageCode.includes(item.code)) {
        open(`${res.data.retVal.appUrl}&language=${language}`, true);
      } else {
        if (item.isThird === "T") {
          open(appUrl, true);
        } else {
          //本地应用打开
          _this.$router.push({
            path: item.code + "/"
          });
        }
      }
    }
  }
};

/**
 * 跳转到费用中心
 */
export const goToExpense = async () => {
  const code = "EXPENSE_CENTER";
  const res = await getRedirectUrl(code);
  if (res.data && res.data.result == 0) {
    const {
      appUrl
    } = res.data.retVal;
    open(`${appUrl}&language=${language}`, true);
  }
};
export const userTreeChange = user => {
  user.children = user.department;
  user.organizationUsers = user.unOrgUsers;
  user.orgId = user.unitId;
  user.parentId = user.unitId;
  user.type = "UNIT";
  return [user];
};
async function SAML2ApiValid(item) {
  let res = await assertionSMAL2(item.code);
  if (res.data.result) {
    Message.error(res.data.msg);
  } else {
    const htmlString = res.data;
    const blob = new Blob([htmlString], {
      type: "text/html"
    });
    const url = URL.createObjectURL(blob);
    open(url, true);
  }
}